import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled from 'styled-components'

export const StyledRenewedTooltipContent = styled(Flexbox)(({theme: {palette}}) => ({
    color: palette.success[500]
}))
